import { Component, OnInit } from '@angular/core';
import { Observable } from "rxjs/Rx";
import { BackendResponse } from "app/model/backend-response.model";
import { CustomHttp } from "app/customhttp";

@Component({
  selector: 'app-admin-account-result',
  templateUrl: './admin-account-result.component.html',
  styleUrls: ['./admin-account-result.component.css']
})
export class AdminAccountResultComponent implements OnInit {

  AccountResponse: BackendResponse;

  constructor(public http: CustomHttp) { }

  ngOnInit() {
    this.http.getSuccessResponseSubject()
      .subscribe(
        (res: BackendResponse) => {
          this.AccountResponse = res;
        }
    );
  }

}



// WEBPACK FOOTER //
// C:/Users/user/Desktop/otojet-git/OtojetUI-Spring-Admin-Project/src/app/admin/admin-account-result/admin-account-result.component.ts